(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["combo-offer-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var grid = document.querySelector('results-list, .product-grid-container');
    var emptyState = document.querySelector('[id^="combo-offer-empty-"]');
    if (!grid || !emptyState) return;

    // Hide grid immediately to prevent flash, reveal only if cart has items
    grid.style.visibility = 'hidden';

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count > 0) {
          grid.style.visibility = '';
          changeButtonText();
        } else {
          grid.style.display = 'none';
          emptyState.style.display = '';
        }
      })
      .catch(function() {
        // On error, show products anyway
        grid.style.visibility = '';
      });

    function changeButtonText() {
      function applyText() {
        var items = document.querySelectorAll('.product-grid__item');
        items.forEach(function(item) {
          var link = item.querySelector('.product-card__link');
          var isFrame = link && /frame|travelogue/i.test(link.getAttribute('href') || '');
          var label = isFrame ? 'Personalize & Claim Discount' : 'Add & Claim Discount';

          var buttons = item.querySelectorAll('[data-add-to-cart]:not(.quick-add__button), [name="add"]:not(.quick-add__button), button[type="submit"]:not(.quick-add__button)');
          buttons.forEach(function(btn) {
            if (btn.dataset.comboModified) return;
            btn.dataset.comboModified = 'true';

            if (isFrame) {
              var productUrl = link.getAttribute('href');
              var anchor = document.createElement('a');
              anchor.href = productUrl;
              anchor.className = btn.className;
              anchor.textContent = label;
              anchor.style.display = 'inline-flex';
              anchor.style.alignItems = 'center';
              anchor.style.justifyContent = 'center';
              anchor.style.textDecoration = 'none';
              btn.parentNode.replaceChild(anchor, btn);
            } else {
              var span = btn.querySelector('span:not(.visually-hidden)') || btn.querySelector('span') || btn;
              if (span.textContent.trim()) span.textContent = label;
            }
          });
        });
      }

      // Run after DOM settles
      setTimeout(applyText, 200);

      // Re-apply on infinite scroll
      var observer = new MutationObserver(function(mutations) {
        if (mutations.some(function(m) { return m.addedNodes.length > 0; })) {
          setTimeout(applyText, 100);
        }
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const track = (action, category) => {
      try {
        const publish = window.Shopify?.analytics?.publish;
        const data = category ? { action, category } : { action };
        if (typeof publish === 'function') publish.call(window.Shopify.analytics, 'share_page_click', data);
      } catch (e) {
        // Analytics must never break the page.
      }
    };

    const selectText = (el) => {
      const range = document.createRange();
      range.selectNodeContents(el);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    };

    const init = (root) => {
      root.querySelectorAll('.share-landing').forEach((section) => {
        if (section.dataset.shareReady) return;
        section.dataset.shareReady = 'true';

        section.querySelectorAll('[data-share-action]').forEach((link) => {
          link.addEventListener('click', () => track(link.dataset.shareAction, link.dataset.shareCategory));
        });

        const copy = section.querySelector('[data-share-copy]');
        const code = section.querySelector('[data-share-code]');
        if (copy && code) {
          const label = copy.querySelector('[data-share-copy-label]');
          let timer;
          const show = (text) => {
            label.textContent = text;
            clearTimeout(timer);
            timer = setTimeout(() => {
              label.textContent = copy.dataset.labelDefault;
            }, 2000);
          };

          copy.addEventListener('click', async () => {
            track('copy_code');
            const value = code.textContent.trim();
            try {
              await navigator.clipboard.writeText(value);
              show(copy.dataset.labelDone);
            } catch (e) {
              // No clipboard API (or permission denied): select the code so it can be copied by hand.
              selectText(code);
              show(copy.dataset.labelSelected);
            }
          });
        }

        const native = section.querySelector('[data-share-native]');
        if (native && typeof navigator.share === 'function') {
          native.hidden = false;
          native.addEventListener('click', () => {
            track('native_share');
            navigator.share({ text: native.dataset.shareText }).catch(() => {});
          });
        }
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
